import { SecureComponent } from 'Components/Security';
import { Permission } from 'Models/Templates/Permission/Permission';
import React, { Fragment, useContext } from 'react';
import { AppointmentDocumentList, AppointmentReportList } from '.';
import { AppointmentLetterList } from './AppointmentLetters';
import { useGlobalContext } from 'Context';
import { AppointmentReportListClients } from './AppointmentReportsClient';

export const AppointmentDocumentsReports: React.FC = () => {
  const globalContext = useGlobalContext();
  const userdata = globalContext[0]?.currentUser;
  const isClient = userdata?.isClient ?? false;
  return (
    <div style={{ overflowY: 'auto', height: '100%' }}>
      {isClient ? (
        <>
          <SecureComponent permissions={[Permission.ViewAppointmentReport]}>
            <AppointmentReportListClients />
          </SecureComponent>
          <SecureComponent permissions={[Permission.ViewAppointmentDocument]}>
            <AppointmentLetterList />
          </SecureComponent>
        </>
      ) : (
        <>
          <SecureComponent permissions={[Permission.ViewAppointmentDocument]}>
            <AppointmentDocumentList />
          </SecureComponent>
          <SecureComponent permissions={[Permission.ViewAppointmentReport]}>
            <AppointmentReportList />
          </SecureComponent>
        </>
      )}
    </div>
  );
};
